export default __webpack_public_path__ + "static/media/huff.546aceb9.png";